import { Components } from '@mui/material/styles/components';
// import theme from '../../provider/controllerBaseTheme';

export const RatingComponent: Components = {
  MuiRating: {
    styleOverrides: {
      root: {},
    },
  },
};
